/**
 * Handler for mslf.afterNavigation, enables client-side validation only if the active
 * panel has any validatable fields. This allows enter-to-continue to work when there
 * are required fields on future steps.
 *
 * @param {Event} event - the mslf.afterNavigation custom event
 */
export default function toggleFormValidation(event) {
  if(!event.defaultPrevented) {
    const { form, targetPanel } = event.detail;
    form.noValidate = !targetPanel.querySelector('[type=submit]');
  }
}
